const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchWATemplates = async ({ channels = [], search = '' } = {}) => {
  try {
    const token = localStorage.getItem('authToken');
    const params = new URLSearchParams();
    if (channels.length) {
      params.append('channel', channels.join(','));
    }
    if (search.trim()) {
      params.append('search', search.trim());
    }

    const response = await fetch(
      `${BASE_URL}/eci/apis/v4/templates/getall_watemplates?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch templates');
    }

    const data = await response.json();
    return data.msg || [];
  } catch (error) {
    console.error('Error fetching WA templates:', error);
    return [];
  }
};


// Update a specific WhatsApp template
export const updateWATemplate = async (templateId, updatedData) => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(
      `${BASE_URL}/eci/apis/v4/templates/${templateId}/edit_watemplate`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updatedData),
      }
    );

    if (!response.ok) {
      throw new Error('Failed to update WA template');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating WA template:', error);
    throw error; 
  }
};
